/**
 * The curated book fonts a theme can name (decision 31: about 8–12 OFL fonts, lazy-loaded, embedded in EPUB
 * and PDF, referenced by name in DOCX; no uploads). A theme stores the ID only; part 12 loads the files. An ID
 * is never removed or renamed once a theme can hold it: a stored theme naming it would stop reading. Adding one
 * is a book-format change too (V14): a build that doesn't know the ID refuses the whole record, so a new font
 * ships with a new book-format version under decision 65's migration rule.
 */
import { frozen } from './record.ts';

/** Every font a theme may name, as stable IDs. */
export const FONT_IDS = frozen([
  'source-serif-4',
  'eb-garamond',
  'crimson-pro',
  'libre-baskerville',
  'literata',
  'lora',
  'alegreya',
  'spectral',
  'cormorant-garamond',
  'pt-serif',
  'source-sans-3',
  'fira-sans',
] as const);

/** A curated font's ID. */
export type FontId = (typeof FONT_IDS)[number];

/** Each font's family name, as DOCX references it and EPUB's CSS names it (decision 31). */
export const FONT_FAMILIES: Readonly<Record<FontId, string>> = frozen({
  'source-serif-4': 'Source Serif 4',
  'eb-garamond': 'EB Garamond',
  'crimson-pro': 'Crimson Pro',
  'libre-baskerville': 'Libre Baskerville',
  literata: 'Literata',
  lora: 'Lora',
  alegreya: 'Alegreya',
  spectral: 'Spectral',
  'cormorant-garamond': 'Cormorant Garamond',
  'pt-serif': 'PT Serif',
  'source-sans-3': 'Source Sans 3',
  'fira-sans': 'Fira Sans',
});
